<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/getWorkHourManagementReport" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="query" class="demo-form-inline">
          <el-form-item :label="$t('xuanzeriqi')">
            <yi_time_input format="yyyy-MM-dd" type="daterange" :minTime="0" :maxTime="365 * 24 * 3600 * 1000" :start.sync="query.startDate" :end.sync="query.endDate"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('banci')">
            <el-select :clearable="true" v-model="query.shiftId" :placeholder="$t('qingxuanze')">
              <el-option v-for="shift in shifts" :label="shift.name" :value="shift.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="query.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="onSearch" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR> </template>
      <!-- 自定义某个字段 -->
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  name: 'web_report_work_hour_management_report_list',
  data() {
    return {
      exportLoading: false,
      shifts:[],
      // 缓存明细数据用于汇总
      detailListCache: [],
      // 本地查询模型，避免与内部 conditions 冲突
      query: {
        equipmentIds: '',
        shiftId: '',
        startDate: null,
        endDate: null,
      },
      // 本地分页缓存（按条件构建key）
      clientPageCacheKey: '',
      clientPageFullRows: [],
      columns: [
        { label: this.$t('banci'), prop: 'shiftName', width: 100 },
        { label: 'riqi', type: 'time', format: 'YYYY-MM-DD', prop: 'workDate', sort: 'number' },
        { label: this.$t('shebeimingcheng'), prop: 'equipmentName', width: 140 },
        { label: this.$t('zonggongshishu(h)'), prop: 'totalWorkingHours', formatter: scope => {
            return scope.row.totalWorkingHours.toFixed(2);
          } },
        { label: this.$t('youxiaoyunxinggongshishu(h)'), prop: 'effectiveHours', formatter: scope => {
            return scope.row.effectiveHours.toFixed(2);
          } },
        { label: this.$t('wuxiaogongshishu(h)'), prop: 'invalidHours', formatter: scope => {
            return scope.row.invalidHours.toFixed(2);
          } },
        { label: this.$t('shebeiyunxingshijian(h)'), prop: 'runDuration', formatter: scope => {
            return scope.row.runDuration.toFixed(2);
          } },
        { label: this.$t('paibanrenshu'), prop: 'employeeCount', width: 120 },
      ],
    };
  },
  mounted() {
    // 监听表格数据变化，缓存明细用于汇总
    this.$nextTick(() => {
      const yt = this.$refs.yt;
      if (!yt) return;
      // 若未设置日期，初始化为昨天，确保日期控件显示
      if (!yt.conditions) {
        this.$set(yt, 'conditions', {});
      }
      if (!yt.conditions.startDate) {
        let s = this.dayjs().subtract(1, 'day').startOf('day').valueOf();
        let e = this.dayjs().endOf('day').valueOf();
        this.$set(yt.conditions, 'startDate', s);
        this.$set(this.query, 'startDate', s);
        this.$set(yt.conditions, 'endDate', e);
        this.$set(this.query, 'endDate', e);
      } else if (!this.query.startDate) {
        this.$set(this.query, 'startDate', yt.conditions.startDate);
        this.$set(this.query, 'endDate', yt.conditions.endDate);
      }
      if (!this.query.startDate) {
        this.$set(this.query, 'startDate', yt.conditions.startDate);
        this.$set(this.query, 'endDate', yt.conditions.endDate);
      }
      // 包装 get，保证分页事件也走前端分页
      this.ensureClientPaging();
    });
  },
  created() {
    this.getShifts();
    this.$set(this.query,'startDate',this.dayjs().subtract(1, 'day').startOf('day').valueOf());
    this.$set(this.query,'endDate',this.dayjs().endOf('day').valueOf());
    setTimeout(() => {
      this.$nextTick(() => {
        this.yt.get(1);
      });
    }, 300);
  },

  methods: {
    getShifts(){
      this.http('/web/setting/shift/getShiftByCustomer').then(res => {
        if (res.data.length > 0) {
          this.shifts = res.data;
        }
      });
    },
    reset() {
      let defaultStartDate = this.dayjs().subtract(1, 'day').startOf('day').valueOf();
      let defaultEndDate = this.dayjs().endOf('day').valueOf();

      if (this.$refs && this.$refs.yt) {
        this.$set(this.$refs.yt, 'conditions', {});
        this.$set(this.$refs.yt.conditions, 'startDate', defaultStartDate);
        this.$set(this.$refs.yt.conditions, 'endDate', defaultEndDate);
      }

      // 同时更新query对象以同步视图
      this.query = {
        equipmentIds: [],
        shiftId: null,
        startDate: defaultStartDate,
        endDate: defaultEndDate
      };
      this.shiftOptions = [];
      this.shiftDisabled = true;
      // 条件变化，清空缓存
      this.clientPageCacheKey = '';
      this.clientPageFullRows = [];
      if (this.$refs && this.$refs.yt) {
        // 保证使用前端分页
        this.ensureClientPaging();
        this.$refs.yt.get(1);
      }
    },
    // 构建用于分页缓存的key（由查询条件+接口路径组成）
    buildCacheKey() {
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (!yt) return '';
      const url = yt.getUrl || '';
      let conditions = yt.conditions || {};
      let pick = {
        equipmentIds: conditions.equipmentIds || '',
        shiftId: conditions.shiftId || '',
        summaryDate: conditions.summaryDate || ''
      };
      try {
        return url + '|' + JSON.stringify(pick);
      } catch (e) {
        return url + '|' + String(pick);
      }
    },
    // 确保所有调用 yt.get 都会携带 afterGet（用于前端分页），并在有缓存时直接本地分页，无需请求
    ensureClientPaging() {
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (!yt || yt.__get_wrapped__) return;
      const originalGet = yt.get.bind(yt);
      yt.get = (pageNum, beforeReq, afterReq) => {
        const key = this.buildCacheKey();
        const hasCache = this.clientPageCacheKey === key && Array.isArray(this.clientPageFullRows) && this.clientPageFullRows.length >= 0;
        if (hasCache) {
          if (typeof pageNum === 'number') yt.pageNum = pageNum;
          const pageSize = yt.pageSize || 10;
          const total = this.clientPageFullRows.length;
          const start = Math.max(0, (Number(yt.pageNum || 1) - 1) * Number(pageSize));
          const end = start + Number(pageSize);
          const sliced = this.clientPageFullRows.slice(start, end);
          yt.total = total;
          yt.list = sliced;
          // 模拟异步返回结构
          return Promise.resolve({ data: { rows: sliced, total } });
        }
        const br = beforeReq || this.beforeGet;
        const ar = afterReq || ((res) => this.afterGet(res));
        return originalGet(pageNum, br, ar);
      };
      yt.__get_wrapped__ = true;
    },
    // afterGet: 将后端一次性返回的 rows 做本地分页切片，并缓存全量数据
    afterGet(result) {
      try {
        const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
        const pageNum = yt ? yt.pageNum : 1;
        const pageSize = yt ? yt.pageSize : 10;
        let fullRows = [];
        if (result && result.data) {
          if (Array.isArray(result.data)) {
            fullRows = result.data;
          } else if (Array.isArray(result.data.rows)) {
            fullRows = result.data.rows;
          } else if (Array.isArray(result.rows)) {
            fullRows = result.rows;
          }
        }
        // 写入缓存key和全量数据
        this.clientPageCacheKey = this.buildCacheKey();
        this.clientPageFullRows = this.utils.copy(fullRows);
        // 汇总依赖全量
        this.detailListCache = this.utils.copy(fullRows);
        const total = fullRows.length;
        const start = Math.max(0, (Number(pageNum) - 1) * Number(pageSize));
        const end = start + Number(pageSize);
        const sliced = fullRows.slice(start, end);
        // 统一转换结构为 { data: { rows, total, ... } }
        const normalized = {
          ...result,
          data: {
            ...(result && typeof result.data === 'object' && !Array.isArray(result.data) ? result.data : {}),
            rows: sliced,
            total: total
          }
        };
        return normalized;
      } catch (e) {
        return result;
      }
    },
    onSearch() {
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (!yt) return;
      if (!yt.conditions) {
        this.$set(yt, 'conditions', {});
      }
      // 将本地查询模型同步到表格条件
      this.$set(yt.conditions, 'equipmentIds', this.query.equipmentIds || []);
      this.$set(yt.conditions, 'shiftId', this.query.shiftId || '');
      this.$set(yt.conditions, 'startDate', this.query.startDate || '');
      this.$set(yt.conditions, 'endDate', this.query.endDate || '');
      // 查询条件变化，清空旧缓存
      this.clientPageCacheKey = '';
      this.clientPageFullRows = [];
      // 保证使用前端分页
      this.ensureClientPaging();
      yt.get(1);
    },
    beforeGet(params) {
      // 从表格条件提取，保证以 conditions 为准
      if (this.yt && this.yt.conditions) {
        params['startDate'] = this.yt.conditions.startDate || this.dayjs().subtract(1, 'day').startOf('day').valueOf();
        params['endDate'] = this.yt.conditions.endDate || this.dayjs().endOf('day').valueOf();
        params['equipmentIds'] = (this.yt.conditions.equipmentIds==null||this.yt.conditions.equipmentIds.length == 0) ? [] : this.yt.conditions.equipmentIds;
        params['shiftId'] = this.yt.conditions.shiftId || '';
      }
      return params;
    },
  }
};
</script>
